import { supabase } from './supabase';

// Sends a prompt to our own /api/ai endpoint (Cloudflare Pages Function),
// which holds the Anthropic key. Returns the response text, or throws.
export async function askAI(prompt, maxTokens = 500) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not signed in.');

  const res = await fetch('/api/ai', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` },
    body: JSON.stringify({ prompt, max_tokens: maxTokens })
  });

  let json = {};
  try { json = await res.json(); } catch { /* non-JSON error page */ }
  if (!res.ok) throw new Error(json.error || `AI request failed (${res.status}).`);
  if (json.text) return json.text;
  throw new Error(`The AI returned no text (stop reason: ${json.stop_reason || 'unknown'}${json.block_types && json.block_types.length ? '; blocks: ' + json.block_types.join(',') : ''}). Try Refresh again.`);
}
